export default __webpack_public_path__ + "static/media/yellow_push_up.8d31210f.png";